
<v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip }">
        <a
            v-on   = "{ ...tooltip }"
            @click.stop = "onClick"
            class="ml-2"
        >
            <div class="b-button">
                <div class="b-icon">
                    <v-icon color="primary">mdi-plus-circle</v-icon>
                </div>
                <div class="b-label">
                    <div style="margin-top: -7px;">
                        {{ label }}
                    </div>
                </div>
            </div>
        </a>
    </template>
    <span>{{ tooltip }}</span>
</v-tooltip>
